import {
    putRouteStatusFinishLoading,
    putRouteStatusFinishRequest,
    putRouteStatusFinishSuccess,
    putRouteStatusFinishReject,
    putRouteStatusFinishReset
} from "../../actions/route/putStatusFinishRoute";

export const putRouteStatusFinish = (formData) => async (dispatch, getState) => {
    dispatch(putRouteStatusFinishLoading());
    try {
        const { data } = await putRouteStatusFinishRequest(formData, getState);
        dispatch(putRouteStatusFinishSuccess(data))
    } catch (error) {
        dispatch(putRouteStatusFinishReject(error))
    } finally {
        setTimeout(() => { dispatch(putRouteStatusFinishReset()) }, 3000);
    }
    return Promise.resolve();
};